export class IncidentCreateOuputData {
  buildingUT: string;
  incidentId: number;
}
